var exports = {
  "a": "DesktopDownloadNagbar.module__platformIcons___LWJNY0",
  "t": "DesktopDownloadNagbar.module__platformIcon___LWJNY0",
};

module.exports = exports;
